import { Datepicker, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { constants } from "shared/constants";
import { dateLocalizationStrings } from "utils/formattingUtils";
import format from "date-fns/format";
import { pl as plLocale } from "date-fns/locale";
import ClearInputIcon from "../clearInputIcon/ClearInputIcon";
import styles from "./dateRangePicker.module.scss";

export interface DateRangePickerProps {
    label?: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    onChange: (startDate: Date | undefined, endDate: Date | undefined) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
    return (
        <Flex column>
            <Text>{props.label}</Text>
            <Flex gap="gap.small" fill className={styles.dateRangePicker} space="between">
                <Flex vAlign="center">
                    <Datepicker
                        key={props.startDate ? "start_date" : "start_date_undf"}
                        inputPlaceholder=""
                        inputOnly
                        allowManualInput
                        selectedDate={props.startDate}
                        onDateChange={(_, data) => props.onChange(data?.value, props.endDate)}
                        formatMonthDayYear={(date: Date, _) => format(date, constants.dateFormat, { locale: plLocale })}
                        {...dateLocalizationStrings}
                    />
                    <ClearInputIcon
                        disabled={!props.startDate}
                        onClick={() => props.onChange(undefined, props.endDate)}
                    />
                </Flex>
                <Flex vAlign="center">
                    <Datepicker
                        key={props.endDate ? "end_date" : "end_date_undf"}
                        inputPlaceholder=""
                        inputOnly
                        allowManualInput
                        selectedDate={props.endDate}
                        onDateChange={(_, data) => props.onChange(props.startDate, data?.value)}
                        formatMonthDayYear={(date: Date, _) => format(date, constants.dateFormat, { locale: plLocale })}
                        {...dateLocalizationStrings}
                    />
                    <ClearInputIcon
                        disabled={!props.endDate}
                        onClick={() => props.onChange(props.startDate, undefined)}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

export default DateRangePicker;
